export default __webpack_public_path__ + "static/media/logo-footer.143c2fc4.png";